import { useState, useEffect } from 'react';
import { createClient } from '@supabase/supabase-js';
import Dashboard from './components/Dashboard';
import AuthUI from './components/AuthUI';

const supabase = createClient('https://ulycllofvttdxaxkylie.supabase.co' , 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVseWNsbG9mdnR0ZHhheGt5bGllIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzczMjUxNDAsImV4cCI6MjA5MjkwMTE0MH0.Rq5z2y7SXNUWlpDXw5MEUguEqxOzp6ma-NDyw6ZCiYA');

function App() {
  const [session, setSession] = useState(null);

  useEffect(() => {
    // Check current session
    supabase.auth.getSession().then(({ data: { session } }) => setSession(session));

    // Listen for sign-in/out changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      {!session ? (
        <AuthUI supabase={supabase} />
      ) : (
        <Dashboard session={session} supabase={supabase} />
      )}
    </div>
  );
}

export default App;
